<template>
    <div>
        <label for="label" class="font-bold">Company/Shared</label>
        <SelectButton class="my-2" v-model="isShared" :options="['Shared', 'Company']" @click="$emit('shared-switched', isShared)" />
    </div>
</template>

<script>
export default {
    name: 'SwitchShared',
    emits: ['shared-switched'],
    props: {
        shared: {
            type: String,
        },
    },
    data() {
        return {
            isShared: this.shared,
        };
    },
};
</script>
